
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/innovative",
      function () {
        return require("private-next-pages/innovative/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/innovative"])
      });
    }
  